var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "city-confirmation" },
    [
      _c("page-info", {
        staticClass: "city-confirmation__info",
        attrs: {
          title: "Уверены, что хотите изменить регион доставки?",
          subtitle:
            "Обращаем ваше внимание, что стоимость и наличие товаров могут измениться"
        }
      }),
      _c(
        "div",
        { staticClass: "city-confirmation__buttons" },
        [
          _c("ui-button", {
            staticClass: "city-confirmation__button",
            attrs: { secondary: "", text: "Отменить" },
            on: {
              click: function($event) {
                return _vm.$emit("choose", false)
              }
            }
          }),
          _c("ui-button", {
            staticClass: "city-confirmation__buttons yes",
            attrs: { text: "Изменить" },
            on: { click: _vm.choose }
          })
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isLoading
            ? _c("ui-loader", {
                staticClass: "city-confirmation__loader",
                attrs: { size: "60" }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }